import { render, staticRenderFns } from "./VideoBox.vue?vue&type=template&id=0c217a6e&scoped=true&"
import script from "./VideoBox.vue?vue&type=script&lang=js&"
export * from "./VideoBox.vue?vue&type=script&lang=js&"
import style0 from "./VideoBox.vue?vue&type=style&index=0&id=0c217a6e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c217a6e",
  null
  
)

export default component.exports